const pms_purchase_status = [
  {
    value: "inquiry",
    name: "Inquiry",
  },
  {
    value: "listed",
    name: "Listed",
  },
  {
    value: "offered",
    name: "Offered",
  },
  {
    value: "contract_accepted",
    name: "Contract Accepted",
  },
  {
    value: "closed",
    name: "Closed",
  },
];

export default pms_purchase_status;



// WEBPACK FOOTER //
// ./src/constants/pms_purchase_status.js